import { render } from "./filter.web.vue?vue&type=template&id=2704cfae&scoped=true&ts=true"
import script from "./filter.web.vue?vue&type=script&scoped=true&lang=ts"
export * from "./filter.web.vue?vue&type=script&scoped=true&lang=ts"

import "./filter.web.vue?vue&type=style&index=0&id=2704cfae&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2704cfae"]])

export default __exports__